import React from 'react';
import styles from './App.module.css';
import { Routes, Route, Navigate,  } from 'react-router-dom';
import Hero from './Componets/Hero/Hero';
import Pricing from './Componets/Pricing/Pricing';
import Home from './Componets/Home';
import Navbar from './Componets/Navbar/Navbar';
import AudioController from './AudioController/AudioController';
import MusicAdmin from './MusicShare/MusicAdmin';
import MusicViewer from './MusicShare/MusicViewer';
import CRMApp from './CRM/CRMApp';
import InvoiceGenerator from './INV/InvoiceGenerator';
import Footer from './Componets/Footer/Footer';

const App = () => {
  return (
    <>
    <div className={styles.appContainer}>
      <Navbar />
       {/* <Home /> */}

      
      <Routes>
 {/* <Route path="/admin" element={<MusicAdmin />} />
 <Route path="/crm" element={<CRMApp />} />
<Route path="/play/:id" element={<MusicViewer />} />
<Route path="/inv" element={<InvoiceGenerator />} /> */}

<Route path="/" element={<Home />} />
      </Routes>
      <Footer/>
    </div>
    </>
  );
};

export default App;